export enum RequestStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  CLASSIFYING = "CLASSIFYING",
  UNDER_REVIEW = "UNDER_REVIEW",
  GOVERNANCE_REVIEW = "GOVERNANCE_REVIEW",
  FUNDING_REVIEW = "FUNDING_REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  IN_EXECUTION = "IN_EXECUTION",
  COMPLETED = "COMPLETED",
  ARCHIVED = "ARCHIVED"
}

export enum ProjectStatus {
  PROPOSED = "PROPOSED",
  EVALUATING = "EVALUATING",
  GOVERNANCE_REVIEW = "GOVERNANCE_REVIEW",
  FUNDING_PENDING = "FUNDING_PENDING",
  APPROVED = "APPROVED",
  DEVELOPMENT = "DEVELOPMENT",
  TESTING = "TESTING",
  DEPLOYED = "DEPLOYED",
  ACTIVE = "ACTIVE",
  MAINTENANCE = "MAINTENANCE",
  DEGRADED = "DEGRADED",
  SUNSET = "SUNSET",
  ARCHIVED = "ARCHIVED"
}

export enum AssetStatus {
  PROPOSED = "PROPOSED",
  UNDER_REVIEW = "UNDER_REVIEW",
  FUNDING_PENDING = "FUNDING_PENDING",
  APPROVED = "APPROVED",
  DEVELOPMENT = "DEVELOPMENT",
  TESTING = "TESTING",
  DEPLOYED = "DEPLOYED",
  ACTIVE = "ACTIVE",
  MAINTENANCE = "MAINTENANCE",
  DEGRADED = "DEGRADED",
  SUNSET = "SUNSET",
  ARCHIVED = "ARCHIVED"
}

export enum DebentureStatus {
  DRAFT = "DRAFT",
  GOVERNANCE_REVIEW = "GOVERNANCE_REVIEW",
  ISSUANCE_APPROVAL = "ISSUANCE_APPROVAL",
  ACTIVE_OFFERING = "ACTIVE_OFFERING",
  FUNDED = "FUNDED",
  EXECUTING = "EXECUTING",
  REVENUE_PHASE = "REVENUE_PHASE",
  REPAYMENT = "REPAYMENT",
  COMPLETED = "COMPLETED",
  DEFAULTED = "DEFAULTED",
  ARCHIVED = "ARCHIVED"
}

export enum TreasuryExposureStatus {
  DRAFT = "DRAFT",
  UNDER_REVIEW = "UNDER_REVIEW",
  APPROVED = "APPROVED",
  ALLOCATED = "ALLOCATED",
  ACTIVE = "ACTIVE",
  CONSUMING = "CONSUMING",
  REVENUE_PHASE = "REVENUE_PHASE",
  REPAID = "REPAID",
  CLOSED = "CLOSED",
  FROZEN = "FROZEN",
  DEFAULTED = "DEFAULTED",
  WRITTEN_OFF = "WRITTEN_OFF",
  ARCHIVED = "ARCHIVED"
}

export enum ACSRuntimeStatus {
  REQUESTED = "REQUESTED",
  CLASSIFIED = "CLASSIFIED",
  GOVERNANCE_CHECK = "GOVERNANCE_CHECK",
  ISOLATION_DEFINED = "ISOLATION_DEFINED",
  PROVISIONING = "PROVISIONING",
  ACTIVE = "ACTIVE",
  MONITORED = "MONITORED",
  MAINTENANCE = "MAINTENANCE",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
  ARCHIVED = "ARCHIVED"
}

export enum RequestType {
  ENTERPRISE_DEVELOPMENT = "ENTERPRISE_DEVELOPMENT",
  DAO_INFRASTRUCTURE = "DAO_INFRASTRUCTURE",
  ECOSYSTEM_INFRASTRUCTURE = "ECOSYSTEM_INFRASTRUCTURE",
  INTERNAL_AXODUS_PRODUCT = "INTERNAL_AXODUS_PRODUCT",
  EXPERIMENTAL_INITIATIVE = "EXPERIMENTAL_INITIATIVE"
}

export enum ProjectType {
  PUBLIC_INFRASTRUCTURE = "PUBLIC_INFRASTRUCTURE",
  DAO_PLUGIN = "DAO_PLUGIN",
  ENTERPRISE_ACS = "ENTERPRISE_ACS",
  INTERNAL_PRODUCT = "INTERNAL_PRODUCT",
  TREASURY_SPONSORED_ASSET = "TREASURY_SPONSORED_ASSET"
}

export enum AssetType {
  PUBLIC_INFRASTRUCTURE = "PUBLIC_INFRASTRUCTURE",
  DAO_ASSET = "DAO_ASSET",
  ENTERPRISE_ASSET = "ENTERPRISE_ASSET",
  INTERNAL_AXODUS_ASSET = "INTERNAL_AXODUS_ASSET",
  EXPERIMENTAL_ASSET = "EXPERIMENTAL_ASSET"
}

export enum FederationLevel {
  LEVEL_0_EXTERNAL_REQUESTER = "LEVEL_0_EXTERNAL_REQUESTER",
  LEVEL_1_VERIFIED_REQUESTER = "LEVEL_1_VERIFIED_REQUESTER",
  LEVEL_2_OPERATIONAL_PARTNER = "LEVEL_2_OPERATIONAL_PARTNER",
  LEVEL_3_FEDERATED_DAO = "LEVEL_3_FEDERATED_DAO",
  LEVEL_4_CONSTITUTIONAL_DAO = "LEVEL_4_CONSTITUTIONAL_DAO",
  LEVEL_5_AXODUS_NATIVE_ENTITY = "LEVEL_5_AXODUS_NATIVE_ENTITY"
}

export enum FederationStatus {
  REQUESTED = "REQUESTED",
  UNDER_REVIEW = "UNDER_REVIEW",
  VERIFIED = "VERIFIED",
  OPERATIONAL = "OPERATIONAL",
  RESTRICTED = "RESTRICTED",
  SUSPENDED = "SUSPENDED",
  ARCHIVED = "ARCHIVED"
}

export enum IdentityType {
  REQUESTER = "REQUESTER",
  DAO = "DAO",
  ENTERPRISE = "ENTERPRISE",
  OPERATIONAL_ASSET = "OPERATIONAL_ASSET",
  PLUGIN = "PLUGIN",
  ACS_RUNTIME = "ACS_RUNTIME",
  FUNDING = "FUNDING",
  DEBENTURE = "DEBENTURE",
  TREASURY = "TREASURY",
  AGENT = "AGENT"
}

export enum VerificationLevel {
  UNVERIFIED = "UNVERIFIED",
  BASIC_VERIFIED = "BASIC_VERIFIED",
  OPERATIONAL_VERIFIED = "OPERATIONAL_VERIFIED",
  GOVERNANCE_VERIFIED = "GOVERNANCE_VERIFIED",
  TREASURY_ELIGIBLE = "TREASURY_ELIGIBLE",
  FEDERATION_APPROVED = "FEDERATION_APPROVED"
}

export enum IdentityStatus {
  CREATED = "CREATED",
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  VERIFIED = "VERIFIED",
  OPERATIONAL = "OPERATIONAL",
  RESTRICTED = "RESTRICTED",
  SUSPENDED = "SUSPENDED",
  TERMINATED = "TERMINATED",
  ARCHIVED = "ARCHIVED"
}

export enum PluginType {
  GOVERNANCE = "GOVERNANCE",
  TREASURY = "TREASURY",
  ACS = "ACS",
  DAO_UTILITY = "DAO_UTILITY"
}

export enum PluginStatus {
  PLUGIN_REQUEST = "PLUGIN_REQUEST",
  CLASSIFICATION = "CLASSIFICATION",
  GOVERNANCE_REVIEW = "GOVERNANCE_REVIEW",
  FUNDING_SELECTION = "FUNDING_SELECTION",
  DEVELOPMENT = "DEVELOPMENT",
  TESTING = "TESTING",
  DEPLOYMENT = "DEPLOYMENT",
  DAO_OPERATIONS = "DAO_OPERATIONS",
  MAINTENANCE = "MAINTENANCE",
  ARCHIVED = "ARCHIVED"
}

export enum FundingType {
  DIRECT = "DIRECT",
  TREASURY = "TREASURY",
  HYBRID = "HYBRID",
  GRANT = "GRANT",
  DEBENTURE = "DEBENTURE"
}

export enum FundingStatus {
  DRAFT = "DRAFT",
  GOVERNANCE_REVIEW = "GOVERNANCE_REVIEW",
  TREASURY_ANALYSIS = "TREASURY_ANALYSIS",
  APPROVAL = "APPROVAL",
  FUNDING_ACTIVE = "FUNDING_ACTIVE",
  EXECUTION = "EXECUTION",
  REVENUE_PHASE = "REVENUE_PHASE",
  SETTLEMENT = "SETTLEMENT",
  CLOSED = "CLOSED",
  ARCHIVED = "ARCHIVED"
}

export enum DebentureType {
  CONVERTIBLE = "CONVERTIBLE",
  NON_CONVERTIBLE = "NON_CONVERTIBLE"
}

export enum TreasuryExposureType {
  DIRECT_TREASURY_ALLOCATION = "DIRECT_TREASURY_ALLOCATION",
  TREASURY_SPONSORSHIP = "TREASURY_SPONSORSHIP",
  TREASURY_GUARANTEE = "TREASURY_GUARANTEE",
  DEBENTURE_EXPOSURE = "DEBENTURE_EXPOSURE",
  OPERATIONAL_COST_EXPOSURE = "OPERATIONAL_COST_EXPOSURE",
  REVENUE_DELAYED_EXPOSURE = "REVENUE_DELAYED_EXPOSURE"
}

export enum RiskTier {
  TIER_1_CRITICAL_INFRASTRUCTURE = "TIER_1_CRITICAL_INFRASTRUCTURE",
  TIER_2_ECOSYSTEM_STRATEGIC = "TIER_2_ECOSYSTEM_STRATEGIC",
  TIER_3_REVENUE_GENERATING = "TIER_3_REVENUE_GENERATING",
  TIER_4_EXPERIMENTAL = "TIER_4_EXPERIMENTAL",
  TIER_5_VENTURE_RISK = "TIER_5_VENTURE_RISK"
}

export enum RevenueSource {
  DIRECT_CONTRACT = "DIRECT_CONTRACT",
  SUBSCRIPTION = "SUBSCRIPTION",
  PLUGIN = "PLUGIN",
  INFRASTRUCTURE = "INFRASTRUCTURE",
  DEBENTURE_BACKED = "DEBENTURE_BACKED",
  TREASURY_ASSET = "TREASURY_ASSET"
}

export enum RevenueStatus {
  PENDING = "PENDING",
  RECEIVED = "RECEIVED",
  CLASSIFIED = "CLASSIFIED",
  ROUTING_APPROVED = "ROUTING_APPROVED",
  SETTLED = "SETTLED",
  DISTRIBUTED = "DISTRIBUTED",
  CLOSED = "CLOSED",
  DISPUTED = "DISPUTED",
  BLOCKED = "BLOCKED",
  PARTIAL_SETTLEMENT = "PARTIAL_SETTLEMENT",
  FAILED = "FAILED",
  ARCHIVED = "ARCHIVED"
}

export enum RevenueRoutingDestination {
  TREASURY = "TREASURY",
  DAO_TREASURY = "DAO_TREASURY",
  BUILDERS = "BUILDERS",
  MAINTAINERS = "MAINTAINERS",
  DEBENTURE_HOLDERS = "DEBENTURE_HOLDERS",
  OPERATIONAL_RESERVE = "OPERATIONAL_RESERVE",
  ECOSYSTEM_INCENTIVES = "ECOSYSTEM_INCENTIVES"
}

export enum ACSRuntimeType {
  INTAKE_ASSISTANT = "INTAKE_ASSISTANT",
  GOVERNANCE_REVIEW_ASSISTANT = "GOVERNANCE_REVIEW_ASSISTANT",
  FUNDING_ANALYSIS_ASSISTANT = "FUNDING_ANALYSIS_ASSISTANT",
  PROJECT_MANAGEMENT_ASSISTANT = "PROJECT_MANAGEMENT_ASSISTANT",
  TELEMETRY_ASSISTANT = "TELEMETRY_ASSISTANT",
  ENTERPRISE_ACS_RUNTIME = "ENTERPRISE_ACS_RUNTIME",
  DAO_ACS_RUNTIME = "DAO_ACS_RUNTIME"
}

export enum ACSIsolationProfile {
  SHARED = "SHARED",
  SCOPED = "SCOPED",
  DEDICATED = "DEDICATED",
  SOVEREIGN = "SOVEREIGN"
}

export enum TelemetryEventType {
  REQUEST_SUBMITTED = "REQUEST_SUBMITTED",
  PROJECT_STATUS_CHANGED = "PROJECT_STATUS_CHANGED",
  ASSET_RUNTIME_UPDATED = "ASSET_RUNTIME_UPDATED",
  FUNDING_STATUS_UPDATED = "FUNDING_STATUS_UPDATED",
  TREASURY_EXPOSURE_UPDATED = "TREASURY_EXPOSURE_UPDATED",
  DEBENTURE_STATUS_UPDATED = "DEBENTURE_STATUS_UPDATED",
  REVENUE_ROUTING_UPDATED = "REVENUE_ROUTING_UPDATED",
  ACS_RUNTIME_UPDATED = "ACS_RUNTIME_UPDATED",
  GOVERNANCE_REVIEW_REQUIRED = "GOVERNANCE_REVIEW_REQUIRED",
  RISK_SIGNAL = "RISK_SIGNAL"
}

export enum TelemetrySeverity {
  INFO = "INFO",
  NOTICE = "NOTICE",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
  EMERGENCY = "EMERGENCY"
}
